import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

const PINE = "#2f5d3a"
const GRID = "rgba(0, 0, 0, 0.06)"

// Monthly passport entries for one sponsored activity. Both arrays come from
// EngagementStats#monthly_series, which pads empty months with zero, so the
// time axis stays even whether or not anything was logged.
export default class extends Controller {
  static values = { labels: Array, counts: Array }

  connect() {
    this.chart = new Chart(this.element, {
      type: "bar",
      data: {
        labels: this.labelsValue,
        datasets: [{
          label: "Entries",
          data: this.countsValue,
          backgroundColor: PINE,
          borderRadius: 3,
          maxBarThickness: 32
        }]
      },
      options: {
        responsive: true,
        // The wrapper sets an explicit height; without this the canvas would
        // hold a 2:1 box instead and flatten the bars on narrow screens.
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
          x: { grid: { display: false } },
          // precision: 0 keeps the ticks whole — half an entry means nothing.
          y: { beginAtZero: true, ticks: { precision: 0 }, grid: { color: GRID } }
        }
      }
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
